import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { addFieldData, setReturnedValue } from "../../actions";
import InputLabel from "@material-ui/core/InputLabel";

class QSelect extends Component {
  state = {
    value: ""
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      return this.props.dataSource[dataKey];
    }
    return null;
  };

  getRenderSelect = data => {
    if (data) {
      return data.map(item => {
        return (
          <MenuItem
            key={item.key}
            value={item.value}
            datavalue={item.dataValue}
          >
            {item.label}
          </MenuItem>
        );
      });
    }
    return [];
  };

  handleChange = event => {
    const keyValueReturned = this.props.step.returned.key;
    if (keyValueReturned && event.target.value) {
      this.props.isValid(true);
      this.props.setReturnedValue({
        idquestion: this.props.questionId,
        response: event.target.value
      });
    } else {
      this.props.isValid(false);
    }
    this.setState({ value: event.target.value });
  };

  render() {
    const { step } = this.props;
    const stepData = step.data;
    let data = this.getData();
    if (data && stepData.formatSource) {
      data = stepData.formatSource(data);
    }
    return (
      <div className="custom-select wrap-input">
        <InputLabel>{step.label}</InputLabel>
        {data && (
          <Select value={this.state.value} onChange={this.handleChange}>
            {this.getRenderSelect(data)}
          </Select>
        )}
      </div>
    );
  }
}

QSelect.propTypes = {
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isValid: PropTypes.func,
  questionId: PropTypes.any,
  resetData: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    label: PropTypes.any,
    returned: PropTypes.shape({
      key: PropTypes.any
    })
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    questionId: state.returnedValue.idquestion
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    resetData: key => dispatch(addFieldData(key, null))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QSelect);
